// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getProjectLineItemCharges } from '@/project/api/get-project-line-item-charges';
import { useQuery } from '@tanstack/react-query';

export function useProjectLineItemCharges(
  projectKey: string,
  lineItemKey: string | null
) {
  return useQuery({
    queryKey: ['project', projectKey, 'lineItem', lineItemKey, 'charges'],
    queryFn: () => {
      if (lineItemKey === null) {
        throw new Error('lineItemKey is required');
      }
      return getProjectLineItemCharges(projectKey, lineItemKey);
    },
    enabled: lineItemKey !== null,
  });
}
